import { jsx as c } from "react/jsx-runtime";
import { SearchIcon as C } from "../../icons/index.es.js";
import { forwardRef as S, useState as m, useRef as g, useCallback as y, useImperativeHandle as u, useEffect as V } from "react";
import { useDebounce as x } from "../../hooks/useDebounce.es.js";
import { IconButton as B } from "../Button/Button.es.js";
import { Input as D } from "../Input/Input.container.es.js";
import { chakra as j } from "@chakra-ui/react";
const K = S(
  ({ defaultValue: o, inputProps: h, delay: f = 500, onChange: n, inputRef: a, isFullWidth: l, trackId: p, ...b }, d) => {
    const [r, t] = m(o ?? ""), [v, I] = m(o ?? ""), s = g(null), k = (e) => {
      e.target.value !== r && t(e.target.value);
    }, w = y(() => {
      const e = "";
      n(e), t(e);
    }, [n]);
    u(a, () => s.current), u(
      s,
      //@ts-ignore
      () => ({
        resetValue() {
          t("");
        },
        focus() {
          var e;
          (e = a == null ? void 0 : a.current) == null || e.focus();
        }
      }),
      []
    );
    const i = !!r;
    return V(() => {
      o !== r && t(o ?? "");
    }, [o]), x(
      () => {
        v !== r && (I(r), n(r));
      },
      f,
      [r]
    ), /* @__PURE__ */ c(j.div, { ref: d, width: l ? "100%" : "auto", ...b, children: /* @__PURE__ */ c(
      D,
      {
        onChange: k,
        placeholder: "Search by keyword",
        value: r,
        trackId: p,
        ...h,
        isFullWidth: l,
        ref: s,
        withClearButton: i,
        rightAddon: !i && /* @__PURE__ */ c(
          B,
          {
            size: "sm",
            onClick: w,
            variant: "transparent",
            "aria-label": "Clear",
            icon: /* @__PURE__ */ c(C, { color: "primary.500", "aria-label": "search-icon" })
          }
        )
      }
    ) });
  }
);
export {
  K as SearchInput
};
//# sourceMappingURL=SearchInput.es.js.map
